export const UPDATE_APP_INIT = 'UPDATE_APP_INIT'
export const UPDATE_APP_READY = 'UPDATE_APP_READY'
export const UPDATE_APP_STEP = 'UPDATE_APP_STEP'
export const UPDATE_TOOLBAR_TITLE = 'UPDATE_TOOLBAR_TITLE'
export const UPDATE_USER_LANGUAGE = 'UPDATE_USER_LANGUAGE'
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const DEQUEUE_SNACKBAR = 'DEQUEUE_SNACKBAR'
export const UPDATE_AVAILABLE_LANGUAGES = 'UPDATE_AVAILABLE_LANGUAGES'

export const UPDATE_USER_LOGIN_INFO = 'UPDATE_USER_LOGIN_INFO'
export const REMOVE_USER_LOGIN_INFO = 'REMOVE_USER_LOGIN_INFO'
export const UPDATE_USER_OBJECT = 'UPDATE_USER_OBJECT'
export const UPDATE_USER_CHILDREN = 'UPDATE_USER_CHILDREN'
export const UPDATE_ASSESSMENTS = 'UPDATE_ASSESSMENTS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js